<template>
  <div>
    <vxe-grid
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      size="small"
      ref="table"
      border
      row-id="shipmentBookingCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, trigger: 'row' }"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:append="{ row }">
        <el-tag size="mini" :type="row.isAppend === 'Y' ? '' : 'info'">
          {{ row.v_isAppend }}
        </el-tag>
      </template>
      <template v-slot:currencyTotalAmount="{ row }">
        <span
          >{{ row.v_currencyTotalAmount || 0 }}
          {{ row.v_currencyUnit || '' }}</span
        >
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    onCheckboxChange({ records }) {
      this.$emit('checkbox-change', records)
    },
  },
}
</script>
